import React, { useMemo } from 'react';
import { ISavingsBucket } from '../../interfaces';
import { LatestTransactionsZeroState } from './LatestTransactionsZeroState';
import { LatestTransactionsWrapper } from './LatestTransactionsWrapper';

interface IProps {
    bucketState: ISavingsBucket;
}

export const BucketTransactions = ({ bucketState }: IProps) => {
  const isBucketExist = useMemo(() => (!!bucketState?.accountId), [bucketState]);

  return (
    <div className='py-[40px] px-[40px] w-full h-full relative'>
      {!isBucketExist ? <LatestTransactionsZeroState /> : <LatestTransactionsWrapper />}
    </div>
  );
};
